import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './TopBar.css';

const TopBar = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
    const { t, i18n } = useTranslation();
    const { user } = useAuth();
    const [activeSemester, setActiveSemester] = useState(null);

    useEffect(() => {
        fetchActiveSemester();
    }, []);

    const fetchActiveSemester = async () => {
        try {
            const response = await api.get('/semesters/active');
            if (response.data.success) {
                setActiveSemester(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching active semester:', error);
        }
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const semesterLabel = activeSemester
        ? (i18n.language === 'ar' ? activeSemester.label_ar : activeSemester.label_en)
        : null;

    return (
        <div className="topbar">
            <div className="topbar-content">
                <div className="topbar-left">
                    <button
                        className="mobile-menu-btn"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <span className="material-icons">
                            {isMobileMenuOpen ? 'close' : 'menu'}
                        </span>
                    </button>
                    <button className="services-btn">
                        <span className="material-icons">apps</span>
                        {t('topbar.systemName')}
                    </button>

                    {semesterLabel && (
                        <div className="semester-badge">
                            <span className="material-icons">calendar_today</span>
                            <span className="semester-label">{semesterLabel}</span>
                        </div>
                    )}
                </div>

                <div className="topbar-right">
                    <div className="language-pill">
                        <button
                            className={`lang-option ${i18n.language === 'en' ? 'active' : ''}`}
                            onClick={() => changeLanguage('en')}
                        >
                            EN
                        </button>
                        <button
                            className={`lang-option ${i18n.language === 'ar' ? 'active' : ''}`}
                            onClick={() => changeLanguage('ar')}
                        >
                            AR
                        </button>
                    </div>

                    <NavLink
                        to={user?.role === 'admin' ? '/admin/profile' : '/teacher/profile'}
                        className="user-profile-link"
                        title={t('profile.title')}
                    >
                        <div className="user-profile">
                            <div className="user-info">
                                <span className="user-name">
                                    {i18n.language === 'ar' ? user?.fullNameAr : (user?.fullNameEn || user?.fullNameAr)}
                                </span>
                            </div>
                            <div className="user-avatar">
                                <span className="material-icons">account_circle</span>
                            </div>
                        </div>
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default TopBar;
